import * as types from '../constants/actionTypes';
import * as countryActions from "../graphql/actions/country";
import {addNotification as notify} from 'reapop';
import l10n from "../l10n/localization";
import * as creationActions from "./creation";




export function fetchCountries(force = false) {
    return dispatch => {
        dispatch(loading());
        countryActions.getCountries(
            function(response) {
                dispatch(receiveCountries(response.data.countries));
            },
            function(error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    }
}


export function add(country) {
    return dispatch => {
        dispatch(saving(country));
        countryActions.add(
            function (response) {
                dispatch(saved(response.data.createCountry));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCountry(response.data.createCountry));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            country
        );
    };
}


export function edit(country) {
    let id = country.id;
    delete country.id;
    delete country.__typename;

    return dispatch => {
        dispatch(saving(country));
        countryActions.edit(
            function (response) {
                dispatch(saved(response.data.editCountry));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            country
        );
    };
}


export function loading()
{
    return {
        type: types.LOADING_COUNTRY
    };
}


export function saving(country) {
    return {
        type: types.SAVING_COUNTRY,
        payload: country
    };
}


export function saved(country) {
    return {
        type: types.SAVED_COUNTRY,
        payload: country
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_COUNTRIES,
    };
}

export function receiveCountries(countries)
{
    return {
        type: types.RECEIVED_COUNTRIES,
        payload: countries
    };
}


// WEBPACK FOOTER //
// ./src/actions/country.js